export class PageModel {
  constructor(page?: PageModel) {
    if (page) {
      Object.assign(this, page);
    }
    // djb:hack-to determine where pagination is unexpectedly reset (remove when resolved)
    // page.pageSize = 5;
  }
  page: number = 1;
  // djb:test-override pageSize to all (100000) for testing
  pageSize: number = 24;
  orderBy: string = "";
}
